import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useReferralTracking = () => {
  const updateReferralStatus = useCallback(async (
    userId: string, 
    status: 'trial' | 'paid' | 'cancelled',
    subscriptionAmount?: number
  ) => {
    const referralCode = localStorage.getItem('referralCode');
    
    if (!referralCode) return;

    try {
      // Buscar o crear el tracking
      const { data: existingTracking } = await supabase
        .from('referral_tracking')
        .select('*')
        .eq('affiliate_id', referralCode)
        .eq('referred_user_id', userId)
        .single();

      if (existingTracking) {
        // Actualizar el tracking existente
        await supabase
          .from('referral_tracking')
          .update({
            status,
            ...(status === 'trial' && {
              trial_start_date: new Date().toISOString(),
              trial_end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString()
            }),
            ...(status === 'paid' && {
              conversion_date: new Date().toISOString(),
              subscription_amount: subscriptionAmount || 0 // El trigger calculará automáticamente commission_amount
            })
          })
          .eq('id', existingTracking.id);
      } else {
        // Crear nuevo tracking
        await supabase
          .from('referral_tracking')
          .insert([
            {
              affiliate_id: referralCode,
              referred_user_id: userId,
              status,
              ...(status === 'trial' && {
                trial_start_date: new Date().toISOString(),
                trial_end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString()
              }),
              ...(status === 'paid' && {
                conversion_date: new Date().toISOString(),
                subscription_amount: subscriptionAmount || 0 // El trigger calculará automáticamente commission_amount
              })
            }
          ]);
      }

      // Si el estado es 'paid', actualizar las estadísticas del afiliado
      if (status === 'paid' && subscriptionAmount) {
        const commissionAmount = subscriptionAmount * 0.5; // 50% del precio de la suscripción

        const { data: affiliate } = await supabase
          .from('affiliates')
          .select('total_earnings, pending_payment')
          .eq('user_id', referralCode)
          .single();

        if (affiliate) {
          await supabase
            .from('affiliates')
            .update({
              total_earnings: (affiliate.total_earnings || 0) + commissionAmount,
              pending_payment: (affiliate.pending_payment || 0) + commissionAmount
            })
            .eq('user_id', referralCode);
        }
      }
    } catch (error) {
      console.error('Error updating referral status:', error);
    }
  }, []);

  return { updateReferralStatus };
};

export default useReferralTracking;
